import React from "react";
import { useParams } from "react-router";
import { Col, Row } from "react-bootstrap";
import { FaPaperPlane, FaTrash } from "react-icons/fa";

import Form from "../../../components/Form";
import Input, { File } from "../../../components/Input";
import Container from "../../../components/Admin/Container";
import ButtonsGrid from "../../../components/ButtonsGrid";
import Button from "../../../components/Button";

import useAccessoryAndEquipment from "./useAccessoryAndEquipment";

function AccessoryAndEquipment() {
    const { id } = useParams();

    const {
        nome,
        imagem,
        arquivo,
        handleOnChangeNome,
        handleOnChangeImagem,
        handleOnDeleteImagem,
        handleOnChangeArquivo,
        handleOnDeleteArquivo,
        handleSubmit,
        destroy,
    } = useAccessoryAndEquipment();

    return (
        <Container pageTitle="Acessório e Equipamento">
            <Row className="d-flex justify-content-center">
                <Col md="6" sm="10">
                    <Form onSubmit={handleSubmit}>
                        <Input
                            label="Nome*"
                            value={nome}
                            onChange={handleOnChangeNome}
                        />
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <File
                                    label="Imagem*"
                                    width="200"
                                    height="200px"
                                    accept="image/*"
                                    file={imagem}
                                    onUpload={handleOnChangeImagem}
                                    onDeleteFile={handleOnDeleteImagem}
                                />
                            </Col>
                            <Col className="d-flex justify-content-center">
                                <File
                                    label="Arquivo*"
                                    width="200"
                                    height="200px"
                                    accept=".pdf"
                                    fileType="pdf"
                                    file={arquivo}
                                    onUpload={handleOnChangeArquivo}
                                    onDeleteFile={handleOnDeleteArquivo}
                                />
                            </Col>
                            <ButtonsGrid>
                                <Button variant="success" type="submit">
                                    <FaPaperPlane />
                                    Enviar
                                </Button>
                                {id && (
                                    <Button
                                        variant="outline-danger"
                                        onClick={destroy}
                                    >
                                        <FaTrash />
                                        Remover
                                    </Button>
                                )}
                            </ButtonsGrid>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default AccessoryAndEquipment;
